module.exports = __webpack_public_path__ + "img/mobile/BetBar/Home_button@2x.png?1.0.17";